
export enum DynamicPriceStatusCd {
	ACTIVE = 'Active',
	EXPIRED = 'Expired',
	INACTIVE = 'Inactive',
	PENDING = 'Pending',
	QUOTE_OFF = 'QuoteOff'}

